module.exports = __webpack_public_path__ + "images/sso-new.13238570.webp";